import { render, staticRenderFns } from "./modal-edit-contact.vue?vue&type=template&id=d6ea21a4&"
import script from "./modal-edit-contact.vue?vue&type=script&lang=js&"
export * from "./modal-edit-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports